import { useAuth } from "./useAuth";
import { useIsPro } from "./useIsPro";

/**
 * Kin Inbox isn't publicly launched yet. Full access is admins, the manual
 * per-user tester flag (profiles.inbox_tester, mirrors profiles.is_admin —
 * see supabase/migrations/20260720090000_kin_inbox_tester_allowlist.sql),
 * and any real Kin Pro subscriber — useIsPro() is the exact isProNow check
 * every other Pro feature in the app uses (KinProBadge.tsx, Pro.tsx,
 * Index.tsx, ProSetupFlowModal.tsx), so a manual Pro grant unlocks this the
 * same way it unlocks everything else. NOT the app_settings.kin_inbox_enabled
 * boolean, which stays off/unused now that this is the mechanism. Everyone
 * else gets `hasAccess: false` and should render the locked Kin Pro-teaser
 * state, not have the feature hidden outright.
 */
export function useKinInboxAccess() {
  const { isAdmin, isKinInboxTester, adminLoaded, proLoaded } = useAuth();
  const isPro = useIsPro();
  return {
    hasAccess: isAdmin || isKinInboxTester || isPro,
    loaded: adminLoaded && proLoaded,
  };
}
